import { ApolloLink } from '@apollo/client';

type ConstructorOptions = {
  getTimeout?: () => number | undefined | null;
  getHeaders?: () => {
    [x: string]: string;
  };
};

type Options = {
  getTimeout: () => number | undefined | null;
  getHeaders: () => {
    [x: string]: string;
  };
};

/* The application context is responsible for
 * adding value in the operation context, for example
 * headers values or timeout settings. Those value
 * will be used by other link down the chain, usually
 * (but not limited to) the terminating link that will
 * transform the operation into a result.
 */
class ApplicationContextLink extends ApolloLink {
  options: Options;

  constructor(options: ConstructorOptions) {
    super();
    this.options = {
      getHeaders: () => ({}),
      getTimeout: () => null,
      ...options,
    };
  }

  request(operation: any, forward: any) {
    operation.setContext({
      headers: {
        ...operation.getContext().headers,
        ...this.options.getHeaders(),
      },
      fetchOptions: {
        timeout: this.options.getTimeout(),
        credentials: 'same-origin',
      },
    });

    return forward(operation);
  }
}

export { ApplicationContextLink };
